import { render, staticRenderFns } from "./BlogsForm.vue?vue&type=template&id=94904664&"
import script from "./BlogsForm.vue?vue&type=script&lang=js&"
export * from "./BlogsForm.vue?vue&type=script&lang=js&"
import style0 from "./BlogsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports